import { Component, ElementRef, Input, OnInit,AfterViewChecked } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { BussinessRegAppService } from 'app/service/business-reg-app/bussiness-reg-app.service';
import { Questionnaire } from 'app/shared/models/Questionnaire.modal';
import { clearError, processTextField, submitForm, trcQuest } from 'app/shared/Validator/TRCQues.validator';
import { autoTabWithDash2, autoTabWithDash } from 'app/core/util/autodash';
import { Answer } from 'app/shared/models/Answer.model';
import { CustomAlertModalComponent } from 'app/shared/shared-component/custom-alert-modal/custom-alert-modal.component';
import { TRCNextSteps } from 'app/shared/models/tRCNextSteps.model';
import { TRCFundClasses } from 'app/shared/models/tRCFundClasses.model';
import { QuesDetails } from 'app/shared/models/quesDetails.model';
import { MeasureStruct } from 'app/shared/models/measureStruct.model';
import { BUSINESS_REG_APP_CONSTANT } from 'app/config/business-reg-app.constant';

@Component({
    selector: 'jhi-eappreg-questionnaire',
    templateUrl: './eappreg-questionnaire.component.html',
    styleUrls: ['./eappreg-questionnaire.component.scss']
})
export class EappregQuestionnaireComponent implements OnInit {

    DupEntryGrpRow = 0
    BusGrpRow = 1
    DispOnlyInd = "N"
    DispSeqIndY = "Y"
    DispSeqIndN = "N"
    DispSeqType = "A"
    TRCCurrLevel = 1
    
    qQuestions: Questionnaire[] = []
    qQuestions1: Questionnaire[] = []
    fForm = this.fb.group({})
    formObjArray: any[] = []
    getSSN=''
    getFEIN=''

    TRCQForms: Answer[] =[]
    TRCQGroups = sessionStorage.getItem("TRCQGroups") ? JSON.parse(sessionStorage.getItem("TRCQGroups") ?? "") : "[]"
    trcAppForm = sessionStorage.getItem("TRCAppForm") ? JSON.parse(sessionStorage.getItem("TRCAppForm") ?? "") : "{}"

    systemDate = ""
    errorExist = false
    errorMessage = ""

	trcNextSteps: TRCNextSteps = JSON.parse(sessionStorage.getItem("TRCNextSteps") ?? "{}");
	tempMsg: any;	
	qDetails: QuesDetails[] = [];
	measureStruct: MeasureStruct[] = [];
	tRCFundClasses: TRCFundClasses[] = []
	errEist = false;
	eAppRegConstant = BUSINESS_REG_APP_CONSTANT;
    ngbModalOptions: NgbModalOptions = {
        backdrop: 'static',
        keyboard: false
    };

    constructor(private fb: FormBuilder,private _businessService: BussinessRegAppService, 
        private router: Router, private modalService: NgbModal, private route: ActivatedRoute,
        private el: ElementRef) {
            history.pushState(null, "", window.location.href);
            window.onpopstate = function () {
                history.go(1);
            };

     this.getSSN=this.router.getCurrentNavigation()?.extras.state?.SSN
	this.getFEIN=this.router.getCurrentNavigation()?.extras.state?.FEIN
        this.qQuestions = this.route.snapshot.data["busVerificationQuestions"]
        this.qQuestions1 = this.route.snapshot.data["level1Questions"]
        sessionStorage.setItem("TRCCurrGrpMetaName", "DUPENTRYGRP")
    }
	
    ngOnInit(): void {
			 
 
        const temp = "eappreg"        
        if(sessionStorage.getItem("TRCCurrentPage") === "eappreg_criteria"){
            sessionStorage.setItem("TRCCurrentPage","eappreg_questionnaire") ;                
        }else if(sessionStorage.getItem("TRCCurrentPage") === "eappreg_confirm" || sessionStorage.getItem("TRCCurrentPage") === "eappreg_business_questions" ||
            sessionStorage.getItem("TRCCurrentPage") === "eappreg_permit_questions" || sessionStorage.getItem("TRCCurrentPage") === "eappreg_fasttrack"||        
            sessionStorage.getItem("TRCCurrentPage") === "eappreg_app")            
         {  sessionStorage.setItem("TRCCurrentPage","eappreg_questionnaire") ;
        }
        if(sessionStorage.getItem("TRCCurrentPage") === "eappreg_questionnaire"){
            sessionStorage.setItem("TRCQForms", "[]");
        }else{
            //Didn't come from right program so call error routine.
            this.router.navigate(['error-page'])
        }
    }
    submit(): void {
        this.fForm.markAllAsTouched();
        if (submitForm(this.fForm, this.modalService)) {
			
            for (const key of Object.keys(this.fForm.controls)) {
                if (this.fForm.controls[key].invalid) {
                  const invalidControl = this.el.nativeElement.querySelector('[name="' + key + '"]');
                  invalidControl.focus();
                  break;
                }
            }
            this.formObjArray = []
            Object.keys(this.fForm.value).forEach((elem)=>{
				this.TRCQForms = JSON.parse(sessionStorage.getItem("TRCQForms") ?? "[]")
                const qId = this.TRCQForms.find((ans:Answer)=>ans.metaName === elem)
                const answerObj = new Answer();
                answerObj.answerTxt = this.fForm.get(elem)?.value
                answerObj.questionId = qId !== undefined ? qId.questionId:0
                answerObj.metaName = elem
                this.formObjArray.push(answerObj)
            })
            //  update TRCQForm session data with latest selections
            this._businessService.updateTrcSessionForm({
                "trcFormData": this.formObjArray,
                "trcSessionData": this.TRCQForms,
                "qGrpID": sessionStorage.getItem("TRCBusGrpId")??""
            }).subscribe((res: any) => {
                this.TRCQForms = res
                sessionStorage.setItem("TRCQForms", JSON.stringify(res))
                this.eappreg_questionnaire_action();
            })

        } else {
            trcQuest(this.fForm)
            for (const key of Object.keys(this.fForm.controls)) {
                if (this.fForm.controls[key].invalid) {
                  const invalidControl = this.el.nativeElement.querySelector('[name="' + key + '"]');
                  invalidControl.focus();
                  break;
                }
            }
        }
    }

    eappreg_questionnaire_action(): void {
        this.errorExist = false
        this._businessService.getSystemDate().subscribe((res: string) => {
            this.trcAppForm.postMarkDt = new  Date(res);
            sessionStorage.setItem("TRCAppForm", JSON.stringify(this.trcAppForm))
        })
        const ssn = this.fForm.get("SSN")?.value
        const fein = this.fForm.get("FEIN")?.value
		sessionStorage.setItem("FEIN",fein);
        if (fein.length > 0) {
            this._businessService.getLATAXFEINCnt(fein.split("-").join("")).subscribe((feinRes: any) => {
                if(feinRes.alertMsg !== undefined){
                    const title = "Confirmation"
                    const body = feinRes.alertMsg
                    const modalRef = this.modalService.open(CustomAlertModalComponent, this.ngbModalOptions)
                    modalRef.componentInstance.cModalTitle = title
                    modalRef.componentInstance.cModalBody = body
                    modalRef.result.then((userResponse) => {
                        if (userResponse === "OK") {
                            this.router.navigate(['eappreg_criteria'])
                        }
                    });
                } else {
                const feinQId = this.TRCQForms.find(obj => obj.metaName === "FEIN")
                this._businessService.getWebAnswerCnt(feinQId !== undefined ? feinQId.questionId : 0, fein.split("-").join("")).subscribe((res: any) => {
                    if (res.alertMsg === undefined) {
                        this.initialVariables();
						this.setUpBusinessFundClass();
                    } else {
                        const title = "Confirmation"
                        const body = res.alertMsg
                        const modalRef = this.modalService.open(CustomAlertModalComponent, this.ngbModalOptions)
                        modalRef.componentInstance.cModalTitle = title
                        modalRef.componentInstance.cModalBody = body
                        modalRef.result.then((userResponse) => {
                            if (userResponse === "OK") {
                                this.router.navigate(['eappreg_criteria'])
                            }
                        });
                    }
                })
                }
            })
        } else if (ssn.length > 0) {
            this._businessService.getLATAXSSNCnt(ssn.split("-").join("")).subscribe((ssnRes: any) => {
                if(ssnRes.alertMsg !== undefined){
                    const title = "Confirmation"
                    const body = ssnRes.alertMsg
                    const modalRef = this.modalService.open(CustomAlertModalComponent, this.ngbModalOptions)
                    modalRef.componentInstance.cModalTitle = title
                    modalRef.componentInstance.cModalBody = body
                    modalRef.result.then((userResponse) => {
                        if (userResponse === "OK") {
                            this.router.navigate(['eappreg_criteria'])
                        }
                    });
                }else{
                    const ssnQId = this.TRCQForms.find(obj => obj.metaName === "SSN")
                this._businessService.getWebAnswerCnt(ssnQId !== undefined ? ssnQId.questionId : 0, ssn.split("-").join("")).subscribe((res: any) => {
                    if (res.alertMsg === undefined) {
                         this.initialVariables();
						this.setUpBusinessFundClass();
                    } else {
                        const title = "Confirmation"
                        const body = res.alertMsg
                        const modalRef = this.modalService.open(CustomAlertModalComponent, this.ngbModalOptions)
                        modalRef.componentInstance.cModalTitle = title
                        modalRef.componentInstance.cModalBody = body
                        modalRef.result.then((userResponse) => {
                            if (userResponse === "OK") {
                                this.router.navigate(['eappreg_criteria'])
                            }
                        });
                    }
                })
                } 
            })
        }

    }
    update(answers: Answer[]): void {
        // this.TRCQForms = [...this.TRCQForms,...answers];
        for(let i=0;i<answers.length;i++){
            if(!this.TRCQForms.find(ansObj => ansObj.questionId === answers[i].questionId)){
                this.TRCQForms.push(answers[i])
            }
        }
        sessionStorage.setItem("TRCQForms", JSON.stringify(this.TRCQForms))
this.data();
      }
data(): void {

    const inputElem: any = document.getElementById("level1_table")?.getElementsByTagName("input");

    for (let i = 0; i < inputElem?.length; i++) {
      if (inputElem[i].type === 'radio') {
        (<HTMLElement>inputElem[i]).addEventListener('click', () => {
          clearError(inputElem[i]);
        });
      }
      if (inputElem[i].type === 'text') {
        (<HTMLElement>inputElem[i]).addEventListener('change', () => {
          processTextField(inputElem[i], this.modalService);
        })
      }
    }
  }
    get sessionStorage(): any {
        return sessionStorage;
    }

    ngAfterViewInit(): void {
		if(this.getSSN.length!==0 || this.getFEIN.length!==0){
	this.fForm.controls['SSN'].setValue(this.getSSN)
	this.fForm.controls['FEIN'].setValue(this.getFEIN)
	}
        const inputElem: any = document.getElementById("DUPENTRYGRP")?.getElementsByTagName("input");

        const inputElem2: any = document.getElementById("BUSINESSGRP")?.getElementsByTagName("input");
        for (let i = 0; i < inputElem.length; i++) {
            (<HTMLElement>inputElem[i]).addEventListener('change', () => {
                trcQuest(this.fForm)
            });
            (<HTMLElement>inputElem[i]).addEventListener('keyup', () => {
                this.autodash(event, inputElem[i].name)
            });
        }
        for (let i = 0; i < inputElem2.length; i++) {
            (<HTMLElement>inputElem2[i]).addEventListener('click', () => {
                clearError(inputElem2[i]);
            })
        }
    }

    autodash(event: any, name: string): void {
        if (name === "SSN") {
            autoTabWithDash2(event.target, event.target.maxLength, 3, 6, event)
        } else if (name === "FEIN") {
            autoTabWithDash(event.target, event.target.maxLength, 2, event)
        }
    }

    scrollToError(): void {
        const elementPosition = Number(document.getElementById('alertRef')?.offsetTop);
        window.scrollTo({
          top: elementPosition - 40,
          behavior: "smooth"
        });
      }

initialVariables(): void {

    this.trcNextSteps.exemptFormReq = false;
    this.trcNextSteps.internetFormReq = false;
    this.trcNextSteps.multimediaFormReq = false;
    sessionStorage.setItem("TRCNextSteps", JSON.stringify(this.trcNextSteps))
    this.tempMsg = sessionStorage.setItem("TRCDataErrors", "");
    //sessionStorage.removeItem("TRCDataErrors") ;

    //always create a new list at this point
    if (sessionStorage.getItem("TRCFundClasses")) {

      sessionStorage.removeItem("TRCFundClasses")
      const tRCFundClasses = new TRCFundClasses()
      sessionStorage.setItem("TRCFundClasses", JSON.stringify(tRCFundClasses))

    }

  }
 setUpBusinessFundClass(): void {
	
	 this._businessService.getQuestionDetails(sessionStorage.getItem("TRCBusGrpId") ?? "").subscribe((res: any) => {
      this.qDetails = res;
    let measure = 0
    for (let i = 0; i < this.qDetails.length; i++) {
      const resultArray = this.TRCQForms.find(
        obj => obj.questionId === this.qDetails[i].questionId)
      if (resultArray !== undefined && resultArray.answerTxt === "Y") {

        if (this.qDetails[i].revenueType) {
          if (this.qDetails[i].measureId === 0) {
            const measureSt = new MeasureStruct();
            measureSt.measure = 0;
            this.measureStruct.push(measureSt);
            const fundclIndex =this.tRCFundClasses.findIndex(
              obj => obj.revenue_type === this.qDetails[i].revenueType
              )
            if(fundclIndex >= 0){
              this.tRCFundClasses[fundclIndex].measure = measureSt.measure; 
            }else{
              const trcFundClasses = new TRCFundClasses();
              trcFundClasses.revenue_type = this.qDetails[i].revenueType;
              trcFundClasses.measure = measureSt.measure;
              trcFundClasses.description = this.qDetails[i].description;
              this.tRCFundClasses.push(trcFundClasses);
            }

          } else {
            const resultArray1 = this.TRCQForms.find(
              obj => obj.questionId === this.qDetails[i].measureId
            )
            if (resultArray1 !== undefined) {
              measure = Number(resultArray1.answerTxt);
              if (!this.isNumber(measure)) {
                const title = "Confirmation"
                const body = "Please correct the " + measure + " answer.  It must be numeric only."
                const modalRef = this.modalService.open(CustomAlertModalComponent, this.ngbModalOptions)
                modalRef.componentInstance.cModalTitle = title
                modalRef.componentInstance.cModalBody = body

                measure = 0;
                this.errEist = true
                break;
                return;
              }
              
              const fundclIndex =this.tRCFundClasses.findIndex(obj => obj.revenue_type === this.qDetails[i].revenueType)
              if (fundclIndex>=0) {
                this.tRCFundClasses[fundclIndex].measure = this.tRCFundClasses[fundclIndex].measure+measure
              } else {
                const measureSt = new MeasureStruct();
                measureSt.measure = measure;
                this.measureStruct.push(measureSt);
                const trcFundClasses = new TRCFundClasses();
                trcFundClasses.revenue_type = this.qDetails[i].revenueType;
                trcFundClasses.measure = measureSt.measure;
                trcFundClasses.description = this.qDetails[i].description;
                this.tRCFundClasses.push(trcFundClasses);
              }
            }

          }
        }
        this.trcNextSteps.exemptFormReq = this.trcNextSteps.exemptFormReq || this.qDetails[i].specialForm === "EXEMPT"
        this.trcNextSteps.internetFormReq = this.trcNextSteps.internetFormReq || !!(this.qDetails[i].specialForm === "INTERNET")
        this.trcNextSteps.multimediaFormReq = this.trcNextSteps.multimediaFormReq || !!(this.qDetails[i].specialForm === "MULTIMEDIA")
      }

    }
    sessionStorage.setItem("TRCFundClasses", JSON.stringify(this.tRCFundClasses))
    sessionStorage.setItem("TRCNextSteps", JSON.stringify(this.trcNextSteps))
if (this.errEist === false) {
       						 this.jumpToNxtPage();
   						 }
		})
  }
isNumber(n: any): boolean {
    return /^-?[\d.]+(?:e-?\d+)?$/.test(n);
  }
jumpToNxtPage(): void {
    const tRCFundClasses: TRCFundClasses[] = JSON.parse(sessionStorage.getItem("TRCFundClasses") ?? "");
    const tRCFundClses = this.tRCFundClasses.find(obj => obj.revenue_type === "L050")
    if (tRCFundClasses.length === 0) {

      const title = "Confirmation"
      const body = "Based on the questionnaire answers, we were unable to classify your business.You can double-check your answers.  Did you mean to answer 'no' to all of the additional business activity questions?"
      const modalRef = this.modalService.open(CustomAlertModalComponent, this.ngbModalOptions)
      modalRef.componentInstance.cModalTitle = title
      modalRef.componentInstance.cModalBody = body
      modalRef.result.then((userResponse) => {
        if (userResponse === "OK") {
          this.router.navigate(['/eappreg_questionnaire']);
        }
      });
    } else if (tRCFundClses !== undefined) {
      const title = "Confirmation"
      const body = "The use of online, E-Registration, to register for a Business Tax certificate for a Medical Marijuana Dispensary business is not being accepted at this time.  In addition, mail-in Business Tax Registration application cannot be accepted.  If you operate or plan on operating a Medical Marijuana Dispensary business, you will be required to visit the Office of Finance main public counter office at City Hall, 200 North Spring Street, Room 101, Los Angeles CA 90012 in order to request a Business Tax register for your company.  Thank you."
      const modalRef = this.modalService.open(CustomAlertModalComponent, this.ngbModalOptions)
      modalRef.componentInstance.cModalTitle = title
      modalRef.componentInstance.cModalBody = body
      modalRef.result.then((userResponse) => {
        if (userResponse === "OK") {
          window.location.href = this.eAppRegConstant.OOFHomePage;
        }
      });

    } else {
      sessionStorage.removeItem("TRCDataErrors");
      sessionStorage.setItem("permitQuestions", "[]")
      this.router.navigate(['/eappreg_permit_main']);
    }

  }
}


